module.exports = __webpack_public_path__ + "img/logo-ress.ee0f338a.png";